/**************************************************
 * Nombre:       Formulario_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {EditAttributesOutlined, LinkOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Anuncios = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagenes del anuncion en horizontal (1200px por 600px) y vertical *opcional (600px por
                        800px)</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoImagenCrop ancho={2} alto={1}
                                       dato={'img'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoImagenCrop ancho={6} alto={8}
                                       dato={'imgCell'} {...props}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={EditAttributesOutlined} nombre={'Nombre Boton'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={LinkOutlined} nombre={'Link Boton'}
                                  dato={'link'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Anuncios